import { Divider, Layout, Tag } from 'antd'
import { PropTypes } from 'prop-types'
import React from 'react'
import { useParams } from 'react-router'
import {
  setSearchApiObj,
  setSearchBarValue,
  useQueryActions,
  useQuerysDispatch,
  useQuerysState
} from '../../CandidateContext/SearchQueryContext'
import LocationWrapper from '../Filters/LocationWrapper'
import { AdvancedSearchContainer, FilterContainer, FilterHeading, TagsWrapper } from './style'

const { Sider } = Layout

const SimpleSearchFilter = ({ setAdvanceSearchVal }) => {
  const [refresh, setRefresh] = React.useState(false)
  const { isLoading, searchApiObj, searchedCandidates } = useQuerysState()
  const { title, skills } = useParams()
  const skillsArray = decodeURIComponent(skills).split(',')
  const dispatch = useQuerysDispatch()
  const action = useQueryActions()
  React.useEffect(() => {
    dispatch(
      setSearchApiObj({
        ...searchApiObj,
        mustNotHave: { ...searchApiObj.mustNotHave },
        shouldHave: {
          ...searchApiObj.shouldHave,
          expertise: [...skillsArray],
          current_title: title === 'no_title' ? [] : [decodeURIComponent(title)]
        },
        mustHave: { ...searchApiObj.mustHave, locations: [] }
      })
    )
    dispatch(setSearchBarValue({ title, skills: skillsArray }))
    if (!searchedCandidates) setRefresh(true)
  }, [])

  React.useEffect(() => {
    if (refresh) {
      action.getCandidatesFromSearch({ annotations: searchApiObj })
    }
  }, [refresh])

  return (
    <Sider className="Filters-body" style={isLoading ? { pointerEvents: 'none' } : undefined}>
      <FilterContainer>
        <FilterHeading>Search by Job Title</FilterHeading>
        {title !== 'no_title' && (
          <TagsWrapper>
            {' '}
            <Tag>{decodeURIComponent(title)}</Tag>
          </TagsWrapper>
        )}
        <Divider />
        <FilterHeading>Skills</FilterHeading>
        <TagsWrapper>
          {skillsArray.map((item, ind) => (
            <Tag className="skills-tag" key={ind}>
              {decodeURIComponent(item)}
            </Tag>
          ))}
        </TagsWrapper>
        <Divider />
        {/* <FilterHeading>Location</FilterHeading>
        {location !== "no_location" && <LocationHeading>City, State</LocationHeading>}
        <TagsWrapper>
          <Tag>{location === "no_location" ? "Remote" : location}</Tag>
        </TagsWrapper> */}
        <LocationWrapper />
        <Divider />
        <AdvancedSearchContainer>
          <div>
            <span
              className={isLoading ? 'disable-link-style' : 'link-style'}
              onClick={() => setAdvanceSearchVal(true)}
            >
              Click Here,
            </span>
            <span>{' for Advanced Search'}</span>
          </div>
        </AdvancedSearchContainer>
      </FilterContainer>
    </Sider>
  )
}
SimpleSearchFilter.propTypes = {
  setAdvanceSearchVal: PropTypes.func
}

export default SimpleSearchFilter
